export const getImageTags = img => {
  if (!img) {
    return []
  }

  const { session = '', tags = [], track_sector = '' } = img || {}
  const { car_model, car_orientation } = tags[0] || {}
  return [car_model, car_orientation, session, track_sector].filter(el => !!el && el !== 'n/a')
};
